import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { ActivatedRoute, Router } from '@angular/router';
import { EEntityTypes } from '../enums';


@Component({
  selector: 'app-entity-navigator',
  templateUrl: './entity-navigator.component.html',
  styleUrls: ['./entity-navigator.component.css']
})
export class EntityNavigatorComponent implements ICellRendererAngularComp {

  public params: ICellRendererParams;
  agRowData: any;

  constructor(private router: Router, private route: ActivatedRoute) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.agRowData = params.node.data;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  navigateToEntity(params) {
    let path = [];
    if(params.data.entityType === EEntityTypes.MODELS) {
      path = ['/models/edit'];
    } else if(params.data.entityType === EEntityTypes.COMPONENTS) {
      path = ['/components/edit']
    }

    this.router.navigate(
      path,
      {relativeTo: this.route,queryParams: {'id': params.data.entityId}}
    );
  }
}
